import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import StudentDashboard from './dashboard/StudentDashboard';
import './Dashboard.css';

/**
 * Student dashboard route (`/dashboard`).
 * Admins are sent to `/admin` — never mount AdminDashboard here so students
 * (and PayFast return → "Back to Dashboard") never see admin permission UI.
 */
const Dashboard: React.FC = () => {
  const { user } = useAuth();

  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  if (isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return <StudentDashboard />;
};

export default Dashboard;
